export default class StatisticExportCtrl {
    constructor($scope, $filter, $state, $stateParams, SideMenu, Statistics, Campaign, Automation, Transaction, Tag, Events, AbTest) {

        this._scope = $scope;
        this._filter = $filter;
        this._state = $state;
        this._stateParams = $stateParams;

        this.statisticsRepo = Statistics;
        this.campaignRepo = Campaign;
        this.transactionRepo = Transaction;
        this.automationRepo = Automation;
        this.abTestRepo = AbTest;
        this.tagRepo = Tag;
        this.eventsRepo = Events;

        this.includeAll = [];
        this.groupSettings = [];
        this.dispatcherType = this._stateParams.dispatcherType;
        this.endDate = this._stateParams.endDate;
        this.startDate = this._stateParams.startDate;
        this.messageType = this._stateParams.messageType ? this._stateParams.messageType : 'email';
        this.statusCount = 0;
        this.totalSent = 0;
        this.totalClicked = 0;
        this.links = [];
        this.links.push({
            'link_id' : 0,
            'link' : 'All links'
        });

        if (this.dispatcherType === 'automation') {
            SideMenu.setActive('automation');
        } else {
            SideMenu.setActive('campaign');
        }

        this.typesMap = {
            'email': [
                { name: this._filter('translate')('STATISTIC:EXPORT:OPENED_DESC'), type: 'open' },
                { name: this._filter('translate')('STATISTIC:EXPORT:CLICKED_DESC'), type: 'link' },
                { name: this._filter('translate')('STATISTIC:EXPORT:IN_BROWSER_DESC'), type: 'browser' },
                { name: this._filter('translate')('STATISTIC:EXPORT:RECEIVED_DESC'), type: 'received' },
                { name: this._filter('translate')('STATISTIC:EXPORT:UNSUBSCRIBED_DESC'), type: 'unsubscribed' },
                { name: this._filter('translate')('STATISTIC:EXPORT:HARD_BOUNCE_DESC'), type: 'hard_bounce' },
                { name: this._filter('translate')('STATISTIC:EXPORT:SOFT_BOUNCE_DESC'), type: 'soft_bounce' },
                { name: this._filter('translate')('STATISTIC:EXPORT:SPAM_DESC'), type: 'spam' }
            ],
            'textMessage': [
                { name: this._filter('translate')('STATISTIC:EXPORT:CLICKED_DESC'), type: 'link' },
                { name: this._filter('translate')('STATISTIC:EXPORT:RECEIVED_DESC'), type: 'received' }
            ]
        };

        this.types = this.typesMap[this.messageType];

        if (this._stateParams.statistic !== 'received') {
            this.selections = [
                { name: this._filter('translate')('GLOBAL:HAS'), value: true },
                { name: this._filter('translate')('GLOBAL:HAS_NOT'), value: false }
            ];
        } else {
            this.selections = [
                { name: this._filter('translate')('GLOBAL:HAS'), value: true }
            ];
        }

        this.exportWrapper = {
            toTag: false,
            tagIds: [],
            hasStatistic: localStorage.getItem('hasStatistic') ? localStorage.getItem('hasStatistic') === 'true' : false,
            statisticType: this._stateParams.statistic,
            campaignId: this._stateParams.id,
            startDate: this.startDate,
            endDate: this.endDate
        };
        this.settings = {
            startDate: this.startDate ? moment(this.startDate) : moment().subtract(6, 'months'),
            endDate: this.endDate ? moment(this.endDate) : moment(),
            type: this._stateParams.statistic,
            currentLinkId: this._stateParams.link ? parseInt(this._stateParams.link) : this.links[0].link_id,
            disabledDispatchers: this._stateParams.disabledDispatchers,
            messageType: this.messageType
        };

        if (this._stateParams.dispatcherType === 'campaign' || this._stateParams.dispatcherType === 'transactional') {
            var neededRepo = this._stateParams.dispatcherType === 'campaign'? this.campaignRepo : this.transactionRepo;
            neededRepo.find(this._stateParams.id).then((campaign) => {
                this.dispatcher = campaign.data;
                if (this.settings.type === 'link') {
                    this.statisticsRepo.getLinks(this.dispatcher.id, this.dispatcherType, this.settings).then((res) => {

                        angular.forEach(res, (link, index) => {
                            this.links.push(link);
                            if (this._stateParams.link) {
                                this.settings.currentLinkId = parseInt(this._stateParams.link);
                            } else if (index === 0) {
                                this.settings.currentLinkId = link.link_id;
                            }
                        });
                    });
                }

                this.getCounts(this.dispatcher.id, this.dispatcherType, this.settings.type);
            });
        }

        if (this.dispatcherType === 'automation') {
            let findFunction = this.messageType == 'email' ? 'findEmail' : 'findTextMessage';
            this.automationRepo[findFunction]($stateParams.automationId, this._stateParams.id).then((automation) => {
                this.dispatcher = automation.data;
                this.dispatcher.name = this.dispatcher.subject;
                if (this.settings.type === 'link') {
                    this.statisticsRepo.getLinks(this.dispatcher.id, this._stateParams.dispatcherType, this.settings).then((res) => {
                        angular.forEach(res, (link, index) => {
                            this.links.push(link);
                            if (this._stateParams.link) {
                                this.settings.currentLinkId = parseInt(this._stateParams.link);
                            } else if (index === 0) {
                                this.settings.currentLinkId = link.link_id;
                            }
                        });
                    });
                }
                this.getCounts(this._stateParams.id, this._stateParams.dispatcherType, this.settings.type);
            });
        }

        if (this._stateParams.dispatcherType === 'abTest') {
            this.abTestRepo.find(this._stateParams.id).then((campaign) => {
                this.dispatcher = campaign.data;
                if (this.settings.type === 'link') {

                    this.statisticsRepo.getLinksByAbTest(this.dispatcher.id, this.settings).then((res) => {

                        angular.forEach(res, (link, index) => {
                            this.links.push(link);
                            if (this._stateParams.link) {
                                this.settings.currentLinkId = parseInt(this._stateParams.link);
                            } else if (index === 0) {
                                this.settings.currentLinkId = link.link_id;
                            }
                        });
                    });
                }

                this.getCounts(this.dispatcher.id, this.dispatcherType, this.settings.type);
            });
        }

        this.tagRepo.all().then((tags) => {
            this.tags = tags.data;
        });
    }

    getCounts(dispatcherId, dispatcherType) {
        if (dispatcherType === 'campaign' || dispatcherType === 'automation' || dispatcherType === 'transactional') {
            this.statisticsRepo.getStatusCounts(dispatcherId, dispatcherType, this.settings).then((counts) => {
                angular.forEach(counts, (count) => {
                    if (count.type === 'received') {
                        this.totalSent = count['uniqueCount'];
                    }
                    if (count.type === 'link') {
                        this.totalClicked = count['uniqueCount'];
                    }
                    if (count.type === this.settings.type) {
                        this.statusCount = count['uniqueCount'];
                    }
                });
            });
        }

        if (dispatcherType === 'abTest') {
            this.statisticsRepo.getAbStatusCounts(dispatcherId, this.settings).then((response) => {
                var campaigns = response.stats;
                angular.forEach(campaigns, (campaign) => {
                    _.map(campaign.counts, (count) => {
                        if (count['type'] === 'received') {
                            this.totalSent += count['uniqueCount'];
                        }
                        if (count['type'] === 'link') {
                            this.totalClicked += count['uniqueCount'];
                        }
                        if (count['type'] === this.settings.type) {
                            this.statusCount += count['uniqueCount'];
                        }
                    });
                });
            });
        }
    };

    changeStatisticType() {
        if (this.settings.type !== this._stateParams.type) {
            if (this.settings.type !== 'link') {
                this.settings.currentLinkId = null;
            }

            if(this._stateParams.dispatcherType === 'automation') {
                this._state.go('statistic.automationexport', {
                    dispatcherType: this.dispatcherType,
                    id: this._stateParams.id,
                    automationId: this._stateParams.automationId,
                    statistic: this.settings.type,
                    disabledDispatchers: this.settings.disabledDispatchers,
                    link: this.settings.currentLinkId
                });
            } else {
                this._state.go('statistic.export', {
                    dispatcherType: this.dispatcherType,
                    id: this._stateParams.id,
                    statistic: this.settings.type,
                    disabledDispatchers: this.settings.disabledDispatchers,
                    link: this.settings.currentLinkId
                });
            }
        }
    };

    export() {
        this.exportWrapper.link = this.settings.currentLinkId;
        if (this.exportWrapper.hasStatistic) {
            this.exportWrapper.total = this.statusCount;
        } else {
            this.exportWrapper.total = (this.totalSent - this.statusCount);
        }

        if (this.dispatcherType === 'abTest') {
            this.exportWrapper.abTest = true;
            this.exportWrapper.disabledDispatchers = this._stateParams.disabledDispatchers;

            this.statisticsRepo.exportSubscribers(this.exportWrapper).then(() => {
                this.eventsRepo.flashEvent('notification', this._filter('translate')('STATISTIC:EXPORT:EXPORT_STARTED'));
                this._state.go('campaign.abTestStatistics', { id: this._stateParams.id, folder: 'open' });
            });
        } else if (this.dispatcherType === 'campaign') {
                this.statisticsRepo.exportSubscribers(this.exportWrapper).then(() => {
                    this.eventsRepo.flashEvent('notification', this._filter('translate')('STATISTIC:EXPORT:EXPORT_STARTED'));
                    var folderName = this.messageType == 'textMessage' ? 'received' : 'open';
                    this._state.go('campaign.show', { id: this._stateParams.id, folder: folderName, messageType: this.messageType });
                });
        } else if (this.dispatcherType === 'transactional') {
            this.exportWrapper.messageId = this._stateParams.id;
            this.exportWrapper.isTransactional = true;
            this.exportWrapper.isAutomation = false;
            this.statisticsRepo.exportTransactionalSubscribers(this.exportWrapper).then(() => {
                this.eventsRepo.flashEvent('notification', this._filter('translate')('STATISTIC:EXPORT:EXPORT_STARTED'));
                this._state.go('campaign.transactionshow', { id: this._stateParams.id, folder: 'open', messageType: 'email' });
            });
        } else {
            this.exportWrapper.messageId = this._stateParams.id;
            this.exportWrapper.messageType = this.messageType;
            this.exportWrapper.automationId = this._stateParams.automationId;
            this.exportWrapper.isTransactional = true;
            this.exportWrapper.isAutomation = true;
            this.statisticsRepo.exportTransactionalSubscribers(this.exportWrapper).then(() => {
                this.eventsRepo.flashEvent('notification', this._filter('translate')('STATISTIC:EXPORT:EXPORT_STARTED'));
                var folderName = this.messageType == 'textMessage' ? 'received' : 'open';
                this._state.go('automation.statistics', { id: this._stateParams.id, folder: folderName, automationId: this._stateParams.automationId, messageType: this.messageType });
            });
        }
    };

    ready() {
        if (this.exportWrapper.toTag) {
            return (this.exportWrapper.tagIds.length > 0) ? this.canExport() : false;
        } else {
            return this.canExport();
        }
    };

    canExport() {
        if (this.exportWrapper.hasStatistic) {
            return (this.statusCount > 0);
        } else {
            return ((this.totalSent - this.statusCount) > 0);
        }
    };

    setHasStatistic() {
        localStorage.setItem('hasStatistic', this.exportWrapper.hasStatistic);
    }
}
